import { IconProps } from './IconProps';

export const PauseWhite = (props: IconProps) => {
  return (
    <svg
      style={props.style}
      className={props.className}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 10C11 9.44772 11.4477 9 12 9H16.75C17.3023 9 17.75 9.44772 17.75 10V30C17.75 30.5523 17.3023 31 16.75 31H12C11.4477 31 11 30.5523 11 30V10ZM22.25 10C22.25 9.44772 22.6977 9 23.25 9H28C28.5523 9 29 9.44772 29 10V30C29 30.5523 28.5523 31 28 31H23.25C22.6977 31 22.25 30.5523 22.25 30V10Z"
        fill="white"
      />
    </svg>
  );
};

